// extracted by mini-css-extract-plugin
module.exports = {"Info":"formContent_Info__15f0X","UploadForm":"formContent_UploadForm__1FGd-"};